const SvgComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.168 4.332a1 1 0 0 1 1.54-.842l8.818 5.669a1 1 0 0 1 0 1.682L5.71 16.51a1 1 0 0 1-1.541-.84V4.331Z"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgComponent
